/*
         * @ngdoc function
         * @name ePay.Model:Session_ApplePayShippingContactModel
         * @description
         * Model
         */

export class Session_ApplePayShippingContactModel {
  familyName: string | null | undefined;
  givenName: string | null | undefined;

	constructor(
		familyName?: string, 
		givenName?: string
	) {
		this.familyName = familyName || null;
		this.givenName = givenName || null;
	}
}
